<template>
  <v-row>
    <v-col cols="6">
      <v-text-field
        v-model="inputedValue.saleNumber"
        :placeholder="$t('refund.refund_target-order-number')"
        outlined
        dense
        hide-details
        :height="height"
      >
      </v-text-field>
    </v-col>
    <v-col>
      <!-- 送金番号 -->
      <v-text-field
        v-model="inputedValue.remittanceNumber"
        outlined
        dense
        hide-details
        :placeholder="$t('refund.refund_refund-management-number')"
        :height="height"
      >
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  components: {
    //
  },
  props: {
    value: {},
    height: { default: '32px' }
  },
  data: () => ({
    items: []
  }),
  created() {
    //
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
